import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const AddUserHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-3 sm:gap-4 mb-6">
      <button
        onClick={() => navigate('/role-management')}
        className="w-10 h-10 rounded-2xl bg-white border border-gray-100 flex items-center justify-center text-gray-500 hover:text-gray-900 hover:border-gray-200 transition-colors shadow-sm"
        title="Back to Role Management"
      >
        <ArrowLeft size={20} />
      </button>
      <div>
        <h1 className="text-xl sm:text-2xl font-black text-[#067978] tracking-tight uppercase">Add New Team Member</h1>
        <p className="text-xs sm:text-sm text-gray-500 font-medium mt-0.5">Create access credentials and assign workspace permissions</p>
      </div>
    </div>
  );
};

export default AddUserHeader;
